import Grid from "@mui/material/Grid/Grid";
import {
    CustomLabelMediumBold,
    CustomLabelMediumRegular,
    CustomLabelRegularMedium,
    CustomLabelSmallBold, CustomLabelXSmallRegular,
    CustomLabelMediumSmallBold
} from "../../common/CustomLabel";

import React from "react";
import Box from "@mui/material/Box/Box";

const ToolsWeUSe = ({title, tagline, tools}) => {

    return (
        <>
        <Grid container sx={{paddingBottom: {xs: "0px", md: "50px"}}} justifyContent={"center"}>

            <Grid item container justifyContent={"center"} sx={{marginTop: {xs: "20px", md: "50px"}}}>
                <CustomLabelMediumBold text={title} fontWeight={700} color={"#5E17EB"}/>
            </Grid>
            <Grid item container xs={10} md={6.5} style={{marginTop: "5px"}} justifyContent={"center"} alignItems={"center"}>
                <CustomLabelMediumRegular textAlign={"center"}
                                          text={tagline}
                />
            </Grid>


            <Grid item xs={12} md={12} sx={{padding: {xs: "20px", md: "40px 80px"}}}>
            <Grid container sx={{marginTop: "20px"}}>
                <Grid item xs={12}>
                    <Box sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 8,
                        justifyContent:"center"
                        
                    }}>
                       {/* {tools.map((svg, index) => (
                        <div key={index}>{svg}</div>  // Render each SVG
                    ))} */}
                    {tools.map((item, index) => {
                    if (typeof item === "string") {
                        // Assuming it's an image path
                        return (
                            <img 
                                key={index} 
                                src={item} 
                                alt={`Item ${index + 1}`} 
                                style={{ border: "1px solid #DDDDDD" , borderRadius: 20 , padding: "12px"}} 
                            />
                        );
                    } else {
                        // It's an inline SVG
                        return <div key={index} style={{ border: "1px solid #DDDDDD" , borderRadius: 20 , padding: "12px"}} >{item}</div>;
                    }
                })}
                    </Box>
                </Grid>
            </Grid>
        </Grid>

        </Grid>
        </>
    )
}


export default ToolsWeUSe;
